import { pinia } from '@tools/pinia';
import { createApp } from 'vue';
import NavbarMobile from '@app/layout/nav/mobile/NavbarMobile.vue';

export function initNavbarMobile(): void {
  if (!document.getElementById('navbar-mobile')) {
    return;
  }

  createApp(NavbarMobile)
    .use(pinia)
    .mount('#navbar-mobile');
}
